module.exports = __webpack_public_path__ + "static/img/bg_low@2x.5cae490.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_low@2x.png
// module id = OLbc
// module chunks = 1